(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-picks-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var wrap = document.querySelector('.bpg-slider-wrap');
  var track = document.querySelector('.bpg-slider');
  if (!wrap || !track) return;

  var currentHandle = (wrap.getAttribute('data-current-product') || '').trim();
  var cards = Array.prototype.slice.call(track.querySelectorAll('.ccg-card'));
  if (cards.length === 0) return;

  console.log('[Best Picks] Current PDP handle:', currentHandle);
  console.log('[Best Picks] All card handles in DOM:', cards.map(function (c) { return c.getAttribute('data-handle'); }));

  // ── Separate eligible cards, remove current product from DOM ──
  var eligible = [];
  cards.forEach(function (card) {
    if (card.getAttribute('data-handle') === currentHandle) {
      card.remove();
    } else {
      eligible.push(card);
    }
  });
  if (eligible.length === 0) return;

  console.log('[Best Picks] Eligible handles after exclusion:', eligible.map(function (c) { return c.getAttribute('data-handle'); }));

  // ── Fisher-Yates shuffle ──
  for (var i = eligible.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = eligible[i];
    eligible[i] = eligible[j];
    eligible[j] = temp;
  }

  // ── Re-append in shuffled order ──
  eligible.forEach(function (card) {
    track.appendChild(card);
  });

  console.log('[Best Picks] Final DOM handles:', Array.prototype.map.call(track.querySelectorAll('.ccg-card'), function (c) { return c.getAttribute('data-handle'); }));

  // ── Carousel state ──
  var currentIndex = 0;
  var visibleCount = getVisibleCount();

  // ── Size cards to fit wrapper content area ──
  function sizeCards() {
    visibleCount = getVisibleCount();
    var wrapCS = window.getComputedStyle(wrap);
    var padL = parseFloat(wrapCS.paddingLeft) || 0;
    var padR = parseFloat(wrapCS.paddingRight) || 0;
    var contentWidth = wrap.clientWidth - padL - padR;
    var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
    var cardWidth = (contentWidth - gap * (visibleCount - 1)) / visibleCount;

    var allCards = track.querySelectorAll('.ccg-card');
    for (var k = 0; k < allCards.length; k++) {
      allCards[k].style.width = cardWidth + 'px';
    }

    // Clamp index after resize
    var maxIndex = Math.max(0, allCards.length - visibleCount);
    if (currentIndex > maxIndex) currentIndex = maxIndex;
    updateTrack();
  }

  function getVisibleCount() {
    var w = window.innerWidth;
    if (w < 600) return 1;
    if (w < 1024) return 2;
    return 4;
  }

  // ── Update track position ──
  function updateTrack() {
    var allCards = track.querySelectorAll('.ccg-card');
    if (allCards.length === 0) return;
    var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
    var slideDistance = allCards[0].offsetWidth + gap;
    var offset = currentIndex * slideDistance;
    track.style.transform = 'translateX(-' + offset + 'px)';
    track.style.transition = 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
  }

  // ── Navigation ──
  var prevBtn = document.querySelector('.bpg-nav--prev');
  var nextBtn = document.querySelector('.bpg-nav--next');

  if (prevBtn && nextBtn) {
    prevBtn.addEventListener('click', function () {
      var allCards = track.querySelectorAll('.ccg-card');
      var maxIndex = Math.max(0, allCards.length - visibleCount);
      if (currentIndex > 0) currentIndex--;
      updateTrack();
    });

    nextBtn.addEventListener('click', function () {
      var allCards = track.querySelectorAll('.ccg-card');
      var maxIndex = Math.max(0, allCards.length - visibleCount);
      if (currentIndex < maxIndex) currentIndex++;
      updateTrack();
    });
  }

  // ── Init ──
  sizeCards();
  window.addEventListener('resize', sizeCards);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestseller-showcase"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('[data-slider]');
  sections.forEach(function (section) {
    var sliderId = section.getAttribute('data-slider');
    var track = section.querySelector('[data-track]');
    var slides = track ? track.querySelectorAll('[data-slide]') : [];
    var container = section.closest('.bs-container');
    var prevBtn = container.querySelector('[data-prev]');
    var nextBtn = container.querySelector('[data-next]');
    var dots = container.querySelectorAll('[data-dot]');
    var total = slides.length;
    if (total < 2) return;

    var current = 0;
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function setActiveDot(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function goTo(index) {
      /* Mobile drives navigation via native scroll (see updateDotFromScroll
         below) — the old transform track-shift must never run there, or it
         would fight the browser's own scroll position. */
      if (mobileQuery.matches) return;

      if (index < 0) index = 0;
      if (index >= total) index = total - 1;
      current = index;

      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });

      setActiveDot(current);

      if (prevBtn) {
        prevBtn.disabled = current === 0;
        prevBtn.style.opacity = current === 0 ? '0.3' : '1';
      }
      if (nextBtn) {
        nextBtn.disabled = current === total - 1;
        nextBtn.style.opacity = current === total - 1 ? '0.3' : '1';
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(current + 1);
      });
    }

    goTo(0);

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        /* On mobile (≤749px) navigation is native touch swipe on .bs-slider
           (see stylesheet); dots stay visible as position indicators but are
           inert here so their transform-based goTo() can't fight the
           native scroll position. */
        if (mobileQuery.matches) return;
        var idx = parseInt(this.getAttribute('data-dot'));
        goTo(idx);
      });
    });

    /* ── Mobile: keep the active dot synced to native scroll position ──
       One dot == one full-width slide/page, so the page index is just the
       scroll offset divided by the per-slide pitch (card width + the 16px
       gap between cards). requestAnimationFrame throttles this to at most
       once per frame during a swipe. */
    var scrollTicking = false;

    function updateDotFromScroll() {
      scrollTicking = false;
      if (!mobileQuery.matches || !slides.length) return;

      var slideWidth = slides[0].getBoundingClientRect().width;
      if (!slideWidth) return;

      var gapPx = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      var pitch = slideWidth + gapPx;
      var index = Math.round(section.scrollLeft / pitch);

      if (index < 0) index = 0;
      if (index > total - 1) index = total - 1;

      setActiveDot(index);
    }

    section.addEventListener('scroll', function () {
      if (!scrollTicking) {
        scrollTicking = true;
        window.requestAnimationFrame(updateDotFromScroll);
      }
    }, { passive: true });

    window.addEventListener('resize', updateDotFromScroll);
    updateDotFromScroll();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curated-collections"] && !Shopify.designMode) return;
  try {
    
  /* <cc-lottie data-src="…json">: plays a Lottie animation once it nears the viewport.
     lottie-web (light SVG build) is loaded once, only when the first icon needs it. */
  if (!customElements.get('cc-lottie')) {
    const LOTTIE_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie_light.min.js';
    let lottieReady = null;

    const loadLottie = () => {
      if (window.lottie) return Promise.resolve(window.lottie);
      if (!lottieReady) {
        lottieReady = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = LOTTIE_SRC;
          script.async = true;
          script.onload = () => resolve(window.lottie);
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }
      return lottieReady;
    };

    class CcLottie extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.src) return;
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.play();
          },
          { rootMargin: '200px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.animation) this.animation.destroy();
        this.animation = null;
      }

      async play() {
        try {
          // new URL() percent-encodes the space in "Grain Grows.json".
          const src = new URL(this.dataset.src, window.location.href).href;
          const [lottie, animationData] = await Promise.all([
            loadLottie(),
            fetch(src).then((response) => {
              if (!response.ok) throw new Error(`HTTP ${response.status} for ${src}`);
              return response.json();
            })
          ]);
          if (!this.isConnected || this.animation) return;
          this.animation = lottie.loadAnimation({
            container: this,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData,
            // Source is 16:9 with the plant centred — crop to the square icon box.
            rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
          });
        } catch (error) {
          console.error('cc-lottie: failed to load animation', error);
        }
      }
    }

    customElements.define('cc-lottie', CcLottie);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  if (!customElements.get('mb-blog-feed')) {
    class MbBlogFeed extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.mb-grid');
        this.sentinel = this.querySelector('.mb-feed__sentinel');
        this.nextUrl = this.dataset.nextUrl || null;
        this.loading = false;
        if (!this.nextUrl || !this.grid || !this.sentinel) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.loadNext();
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        this.observer.observe(this.sentinel);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      async loadNext() {
        if (this.loading || !this.nextUrl) return;
        this.loading = true;

        const url = new URL(this.nextUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);

        try {
          const response = await fetch(url.toString());
          if (!response.ok) throw new Error(response.status);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const feed = doc.querySelector('mb-blog-feed');

          const seen = new Set(
            Array.from(this.grid.querySelectorAll('.bj-card__media'), (a) => a.getAttribute('href'))
          );
          const fragment = document.createDocumentFragment();
          (feed ? feed.querySelectorAll('.mb-grid > .bj-card') : []).forEach((card) => {
            const href = card.querySelector('.bj-card__media')?.getAttribute('href');
            if (href && seen.has(href)) return;
            seen.add(href);
            const newCard = document.importNode(card, true);
            newCard.classList.add('mb-feed__card--new');
            // Drop the class once faded in so this card never re-animates.
            newCard.addEventListener(
              'animationend',
              () => newCard.classList.remove('mb-feed__card--new'),
              { once: true }
            );
            fragment.appendChild(newCard);
          });
          this.grid.appendChild(fragment);

          this.nextUrl = (feed && feed.dataset.nextUrl) || null;
        } catch (error) {
          console.error('mb-blog-feed: failed to load more articles', error);
          this.nextUrl = null;
        }

        this.loading = false;

        if (!this.nextUrl) {
          this.observer.disconnect();
          this.sentinel.remove();
          return;
        }
        // Re-observe so a sentinel that is still in view triggers the next batch.
        this.observer.unobserve(this.sentinel);
        this.observer.observe(this.sentinel);
      }
    }

    customElements.define('mb-blog-feed', MbBlogFeed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
